// @flow
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const masterCellDataActions = {
  GET_MASTER_CELL_DATA: 'GET_MASTER_CELL_DATA',
  ENABLE_DISABLE_SHOPFLOOR: 'ENABLE_DISABLE_SHOPFLOOR',
  CREATE_UPDATE_CELL_PREFIX: 'CREATE_UPDATE_CELL_PREFIX',
  GET_SHOP_FLOOR_STATUS: 'GET_SHOP_FLOOR_STATUS'
};

export const failureMessages = {
  GET_MASTER_CELL_DATA: 'Could not fetch shop floor cell data',
  ENABLE_SHOPFLOOR: 'Could not enable shop floor',
  DISABLE_SHOPFLOOR: 'Could not disable shop floor',
  CREATE_CELL_PREFIX: 'Could not create cell prefix',
  EDIT_CELL_PREFIX: 'Could not edit cell prefix',
  GET_SHOP_FLOOR_STATUS: 'Could not fetch shop floor status'
};

export const successMessages = {
  ENABLE_SHOPFLOOR: 'Shop floor enabled successfully',
  DISABLE_SHOPFLOOR: 'Shop floor disabled successfully',
  CREATE_CELL_PREFIX: 'Cell Prefix created successfully',
  EDIT_CELL_PREFIX: 'Cell Prefix data changed successfully'
};

export const loadingMessages = {
  ENABLE_SHOPFLOOR: 'Enabling shop floor status...',
  DISABLE_SHOPFLOOR: 'Disabling shop floor status...',
  CREATE_CELL_PREFIX: 'Creating cell prefix...',
  EDIT_CELL_PREFIX: 'Updating cell prefix...'
};

export const getMasterCellDataAction = (obj: Object) => ({
  type: masterCellDataActions.GET_MASTER_CELL_DATA,
  payload: obj
});

export const getShopfloorStatusAction = (obj: Object) => ({
  type: masterCellDataActions.GET_SHOP_FLOOR_STATUS,
  payload: obj
});

export const addCellPrefixAction = (obj: Object) => ({
  type: masterCellDataActions.CREATE_UPDATE_CELL_PREFIX,
  payload: obj
});

export const getBaseFailureObject = (
  res: Object,
  errorMessage: String,
  defaultObject: Object
) =>
  Object.assign({}, defaultObject, {
    isLoaded: true,
    isLoading: false,
    error: (res && res.errorMessage) || errorMessage,
    boomerang: {
      component: 'toastr',
      type: 'error',
      removeExistingBms: true,
      heading: 'Error',
      message: (res && res.errorMessage) || errorMessage,
      timeOut: 3000
    }
  });

export function getBaseSuccessfulObject(
  response: Object,
  successMessage: String
) {
  return Object.assign({}, response, {
    isLoading: false,
    isLoaded: true,
    boomerang: {
      component: 'toastr',
      type: 'success',
      removeExistingBms: true,
      heading: 'Success',
      message: successMessage,
      timeOut: 3000
    }
  });
}

export const getBasePendingApiObject = (
  dataDuringPending: Object,
  loadingMessage: String
) =>
  Object.assign({}, dataDuringPending, {
    isLoading: true,
    isLoaded: false,
    boomerang: {
      component: 'toastr',
      type: 'fetching',
      removeExistingBms: true,
      heading: 'Please wait',
      message: loadingMessage,
      timeOut: 0
    }
  });

export const getMasterCellData = () => (dispatch: Function) => {
  dispatch(
    getMasterCellDataAction({
      isLoading: true,
      isLoaded: false,
      masterCellData: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'cellMasterData',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getMasterCellDataAction({
            isLoading: false,
            isLoaded: true,
            masterCellData: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getMasterCellDataAction(
            getBaseFailureObject(res, failureMessages.GET_MASTER_CELL_DATA, {
              masterCellData: []
            })
          )
        );
      }
    },
    failureCb: res => {
      dispatch(
        getMasterCellDataAction(
          getBaseFailureObject(res, failureMessages.GET_MASTER_CELL_DATA, {
            masterCellData: []
          })
        )
      );
    },
    catchCb: res => {
      dispatch(
        getMasterCellDataAction(
          getBaseFailureObject(res, failureMessages.GET_MASTER_CELL_DATA, {
            masterCellData: []
          })
        )
      );
    }
  };

  return makeApiCall(requestObj);
};

export const enableDisableShopfloorAction = (obj: Object) => ({
  type: masterCellDataActions.ENABLE_DISABLE_SHOPFLOOR,
  payload: obj
});

export const enableDisableShopfloor = (requestParams: Object) => (
  dispatch: Function
) => {
  dispatch(
    enableDisableShopfloorAction(
      getBasePendingApiObject(
        { isShopfloorEnabled: !requestParams.enable },
        loadingMessages.ENABLE_DISABLE_SHOPFLOOR
      )
    )
  );

  const successMsg = isEnabling =>
    isEnabling
      ? successMessages.ENABLE_SHOPFLOOR
      : successMessages.DISABLE_SHOPFLOOR;

  const failureMsg = isEnabling =>
    isEnabling
      ? failureMessages.ENABLE_SHOPFLOOR
      : failureMessages.DISABLE_SHOPFLOOR;

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'enableDisableShopfloor',
    method: 'POST',
    params: requestParams,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          enableDisableShopfloorAction(
            getBaseSuccessfulObject(
              { isShopfloorEnabled: res.payload },
              successMsg(res.payload)
            )
          )
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          enableDisableShopfloorAction(
            getBaseFailureObject(res, failureMsg(requestParams.enable), {
              isShopfloorEnabled: false
            })
          )
        );
      }
    },
    failureCb: res => {
      dispatch(
        enableDisableShopfloorAction(
          getBaseFailureObject(res, failureMsg(requestParams.enable), {
            isShopfloorEnabled: false
          })
        )
      );
    },
    catchCb: res => {
      dispatch(
        enableDisableShopfloorAction(
          getBaseFailureObject(res, failureMsg(requestParams.enable), {
            isShopfloorEnabled: false
          })
        )
      );
    }
  };

  return makeApiCall(requestObj);
};

export const onAddingCellPrefixAction = (requestParams: Object) => (
  dispatch: Function
) => {
  // eslint-disable-next-line
  console.log('create cell prefix: ', requestParams);
  dispatch(
    addCellPrefixAction(
      getBasePendingApiObject(
        { cellData: null },
        loadingMessages.CREATE_UPDATE_CELL_PREFIX
      )
    )
  );
  const isEdit = requestParams && requestParams.length && requestParams[0].id;
  const requestMethod = isEdit ? 'PUT' : 'POST';

  const successMsg = isEditFlag => {
    if (isEditFlag) {
      return `Cell prefix edited successfully`;
    }
    return `Cell prefix created successfully`;
  };

  const failureMsg = isEditFlag =>
    isEditFlag
      ? failureMessages.EDIT_CELL_PREFIX
      : failureMessages.CREATE_CELL_PREFIX;

  const requestObj = {
    apiEndPoint: 'cellMasterData',
    baseUrl: 'zoomWmsBaseUrl',
    method: requestMethod,
    data: requestParams,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          addCellPrefixAction(
            getBaseSuccessfulObject(
              { cellData: res.payload },
              successMsg(isEdit, res)
            )
          )
        );
      } else {
        dispatch(
          addCellPrefixAction(
            getBaseFailureObject(res, failureMsg(isEdit), {
              cellData: null
            })
          )
        );
      }
    },
    failureCb: res => {
      dispatch(
        addCellPrefixAction(
          getBaseFailureObject(res, failureMsg(isEdit), {
            cellData: null
          })
        )
      );
    },
    catchCb: res => {
      dispatch(
        addCellPrefixAction(
          getBaseFailureObject(res, failureMsg(isEdit), {
            cellData: null
          })
        )
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getShopfloorStatus = () => (dispatch: Function) => {
  dispatch(
    getShopfloorStatusAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getShopfloorStatus',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          isShopfloorEnabled: res.payload
        };
        dispatch(getShopfloorStatusAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getShopfloorStatusAction(
            getBaseFailureObject(res, failureMessages.GET_SHOP_FLOOR_STATUS, {
              isShopfloorEnabled: false
            })
          )
        );
      }
    },
    failureCb: res => {
      dispatch(
        getShopfloorStatusAction(
          getBaseFailureObject(res, failureMessages.GET_SHOP_FLOOR_STATUS, {
            isShopfloorEnabled: false
          })
        )
      );
    },
    catchCb: res => {
      dispatch(
        getShopfloorStatusAction(
          getBaseFailureObject(res, failureMessages.GET_SHOP_FLOOR_STATUS, {
            isShopfloorEnabled: false
          })
        )
      );
    }
  };

  return makeApiCall(requestObj);
};
